// removed by extract-text-webpack-plugin
module.exports = {"message":"message__message-S2Cqg","title":"message__title-2JG4C","content":"message__content-2TuHQ"};


//////////////////
// WEBPACK FOOTER
// ./components/order/slider/message/message.css
// module id = 848
// module chunks = 0